export {
  default as brush,
  brushX,
  brushY,
  brushSelection
} from "./src/brush";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-brush/index.js
// module id = 519
// module chunks = 0